module.exports = __webpack_public_path__ + "img/index-d1.43c640ac.png";